const htmlEntitiesMap: Record<string, string> = {
    '&nbsp;': ' ',
    '&semi;': ';',
    '&colon;': ':',
    '&period': '.',
    '&comma;': ',',
    '&sol;': '/',
    '&par;': '(',
    '&rpar;': ')',
    '&equals;': '=',
    '&lt;': '<',
    '&gt;': '>',
    '&les;': '≤',
    '&LessSlantEqual;': '≤',
    '&leqslant;': '≤',
    '&ges;': '≥',
    '&GreaterSlantEqual;': '≥',
    '&geqslant;': '≥',
    '&amp;': '&',
    '&quot;': '"',
    '&#39;': "'",
    '&apos;': "'",
    '&num;': '#',
    '&cent;': '¢',
    '&pound;': '£',
    '&yen;': '¥',
    '&euro;': '€',
    '&copy;': '©',
    '&reg;': '®',
    '&sect;': '§',
    '&deg;': '°',
    '&plusmn;': '±',
    '&para;': '¶',
    '&tdot;': ' ⃛',
    '&TripleDot;': ' ⃛',
    '&middot;': '·',
    '&raquo;': '»',
    '&laquo;': '«',
    '&ndash;': '–',
    '&mdash;': '—',
    '&lsquo;': '‘',
    '&rsquo;': '’',
    '&ldquo;': '“',
    '&rdquo;': '”',
    '&hellip;': '…',
    '&iexcl;': '¡',
    '&iquest;': '¿',
    '&times;': '×',
    '&div;': '÷',
    '&divide;': '÷',
    '&cross;': '✗',
    '&check;': '✓',
    '&checkmark;': '✓',
    '&frac14;': '¼',
    '&frac12;': '½',
    '&frac34;': '¾',
    '&sup2;': '²',
    '&sup3;': '³',
    '&NewLine;': '\n',
    '&Tab;': '\t',
    // Accented characters - French and other common European characters
    '&agrave;': 'à',
    '&aacute;': 'á',
    '&acirc;': 'â',
    '&atilde;': 'ã',
    '&auml;': 'ä',
    '&aring;': 'å',
    '&aelig;': 'æ',
    '&ccedil;': 'ç',
    '&egrave;': 'è',
    '&eacute;': 'é',
    '&ecirc;': 'ê',
    '&euml;': 'ë',
    '&igrave;': 'ì',
    '&iacute;': 'í',
    '&icirc;': 'î',
    '&iuml;': 'ï',
    '&eth;': 'ð',
    '&ntilde;': 'ñ',
    '&ograve;': 'ò',
    '&oacute;': 'ó',
    '&ocirc;': 'ô',
    '&otilde;': 'õ',
    '&ouml;': 'ö',
    '&oslash;': 'ø',
    '&ugrave;': 'ù',
    '&uacute;': 'ú',
    '&ucirc;': 'û',
    '&uuml;': 'ü',
    '&yacute;': 'ý',
    '&thorn;': 'þ',
    '&yuml;': 'ÿ',
    // Uppercase accented characters
    '&Agrave;': 'À',
    '&Aacute;': 'Á',
    '&Acirc;': 'Â',
    '&Atilde;': 'Ã',
    '&Auml;': 'Ä',
    '&Aring;': 'Å',
    '&AElig;': 'Æ',
    '&Ccedil;': 'Ç',
    '&Egrave;': 'È',
    '&Eacute;': 'É',
    '&Ecirc;': 'Ê',
    '&Euml;': 'Ë',
    '&Igrave;': 'Ì',
    '&Iacute;': 'Í',
    '&Icirc;': 'Î',
    '&Iuml;': 'Ï',
    '&ETH;': 'Ð',
    '&Ntilde;': 'Ñ',
    '&Ograve;': 'Ò',
    '&Oacute;': 'Ó',
    '&Ocirc;': 'Ô',
    '&Otilde;': 'Õ',
    '&Ouml;': 'Ö',
    '&Oslash;': 'Ø',
    '&Ugrave;': 'Ù',
    '&Uacute;': 'Ú',
    '&Ucirc;': 'Û',
    '&Uuml;': 'Ü',
    '&Yacute;': 'Ý',
    '&THORN;': 'Þ',
    // Additional common symbols
    '&szlig;': 'ß',
    '&micro;': 'µ',
    '&macr;': '¯',
    '&acute;': '´',
    '&cedil;': '¸',
    '&uml;': '¨',
    '&not;': '¬',
    '&shy;': '­',
    '&ordf;': 'ª',
    '&ordm;': 'º',
};

export function decodeHtmlEntities(text: string): string {
    return text.replace(/&[a-zA-Z0-9#]+;/g, (entity) => {
        return htmlEntitiesMap[entity] || entity;
    });
}
